import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toggleStepsList, toggleResponsesList, selectResponse, selectStep, selectMode, selectFeature } from '../actions/commonActions'
import About3DS2 from '../components/threeDSTwo/steps/About3DS2'
import Building3DS2Integration from '../components/threeDSTwo/steps/Building3DS2Integration'
import ImplementingAuthenticationRequest from '../components/threeDSTwo/steps/ImplementingAuthenticationRequest'
import ImplementingCardLookupRequest from '../components/threeDSTwo/steps/ImplementingCardLookupRequest'
import HandlingChallengeFlow from '../components/threeDSTwo/steps/HandlingChallengeFlow'
import MovingToProductionWith3DS from '../components/threeDSTwo/steps/MovingToProductionWith3DS'
import PerformingAuthorization from '../components/threeDSTwo/steps/PerformingAuthorization'
import Testing3DSIntegration from '../components/threeDSTwo/steps/Testing3DSIntegration'
import References from '../components/threeDSTwo/steps/References'
import HandlingDecoupledAuthFlow from '../components/threeDSTwo/steps/HandlingDecoupledAuthFlow'

import Purchase3DS from '../components/threeDSTwo/steps/Purchase3DS'
import Purchase3DSVault from '../components/threeDSTwo/steps/Purchase3DSVault'
import Purchase3DSRec from '../components/threeDSTwo/steps/Purchase3DSRec'
import Preauth3DS from '../components/threeDSTwo/steps/Preauth3DS'
import Preauth3DSVault from '../components/threeDSTwo/steps/Preauth3DSVault'

import CavvPurchaseAppleGoogle from '../components/threeDSTwo/steps/CavvPurchaseAppleGoogle'
import CavvPreAuthAppleGoogle from '../components/threeDSTwo/steps/CavvPreAuthAppleGoogle'
import GooglePayTempToken from '../components/threeDSTwo/steps/GooglePayTempToken'
import GooglePayTokenPreauth from '../components/threeDSTwo/steps/GooglePayTokenPreauth'
import GooglePayTokenPurchase from '../components/threeDSTwo/steps/GooglePayTokenPurchase'

import { FEATURES } from '../constants/common/Features'
import Indicator from '../components/common/Indicator'
import StepsList from '../components/common/StepsList'
import StepsMenu from '../components/common/StepsMenu'
import ResponseList from '../components/common/ResponseList'
import Response from '../components/common/Response'
import Configuration from '../components/threeDSTwo/steps/Configuratoin'
import { _3DS2 } from '../actions/types'
import responses from '../constants/3DS2/responses'
import Footer from '../components/common/Footer'

var isIE = /*@cc_on!@*/false || !!document.documentMode;
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

const scrollToRef = (ref) => {ref.current.scrollIntoView({behavior: "smooth"})}

export class ThreeDSTwo extends Component {
    state = {
        ref1: React.createRef(),
        ref2: React.createRef(),
        ref3: React.createRef(),
        ref4: React.createRef(),
        ref5: React.createRef(),
        ref6: React.createRef(),
        ref7: React.createRef(),
        ref8: React.createRef(),
        ref9: React.createRef(),
        ref10: React.createRef(),
        ref11: React.createRef(),
        ref12: React.createRef(),
        ref16: React.createRef(),
        ref17: React.createRef(),
        ref18: React.createRef(),
        ref19: React.createRef(),
        ref20: React.createRef(),
        ref13: React.createRef(),
        ref14: React.createRef(),
        ref15: React.createRef(),
    }

    componentDidMount() {
        if(this.props.mode === "integration_guide")
            this.scrollIntoStep(this.props.selectedStep);

        document.title = '3D Secure 2.2 | Moneris Developers';
    }

    componentDidUpdate(prevProps) {
        const { selectedStep, mode } = this.props;

        if(mode !== prevProps.mode && mode === 'integration_guide') {
            this.scrollIntoStep(selectedStep)
        }
    }

    isInViewport(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    justLeft(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        const diff = (top - offset) - window.innerHeight;
        return (top + offset) >= 0 && diff > 0 && diff < 100;
    }

    handleScrolling() {
        const { ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10,
                ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20 } = this.state
        
        const { selectStep } = this.props

        if(this.isInViewport(ref1.current) || this.justLeft(ref2.current)) {
            selectStep({stepId: 1, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref2.current) || this.justLeft(ref3.current)) {
            selectStep({stepId: 2, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref3.current) || this.justLeft(ref4.current)) {
            selectStep({stepId: 3, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref4.current) || this.justLeft(ref5.current)) {
            selectStep({stepId: 4, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref5.current) || this.justLeft(ref6.current)) {
            selectStep({stepId: 5, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref6.current) || this.justLeft(ref7.current)) {
            selectStep({stepId: 6, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref7.current) || this.justLeft(ref8.current)) {
            selectStep({stepId: 7, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref8.current) || this.justLeft(ref9.current)) {
            selectStep({stepId: 8, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref9.current) || this.justLeft(ref10.current)) {
            selectStep({stepId: 9, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref10.current) || this.justLeft(ref11.current)) {
            selectStep({stepId: 10, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref11.current) || this.justLeft(ref12.current)) {
            selectStep({stepId: 11, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref12.current) || this.justLeft(ref16.current)) {
            selectStep({stepId: 12, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref16.current) || this.justLeft(ref17.current)) {
            selectStep({stepId: 16, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref17.current) || this.justLeft(ref18.current)) {
            selectStep({stepId: 17, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref18.current) || this.justLeft(ref19.current)) {
            selectStep({stepId: 18, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref19.current) || this.justLeft(ref20.current)) {
            selectStep({stepId: 19, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref20.current) || this.justLeft(ref13.current)) {
            selectStep({stepId: 20, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref13.current) || this.justLeft(ref14.current)) {
            selectStep({stepId: 13, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref14.current) || this.justLeft(ref15.current)) {
            selectStep({stepId: 14, featureId: _3DS2});
            return
        }
        if(this.isInViewport(ref15.current)) {
            selectStep({stepId: 15, featureId: _3DS2});
            return
        }
    }

    scrollIntoStep(stepId) {
        switch(stepId) {
            case 1:
                scrollToRef(this.state.ref1)
                break
            case 2:
                scrollToRef(this.state.ref2)
                break
            case 3:
                scrollToRef(this.state.ref3)
                break
            case 4:
                scrollToRef(this.state.ref4)
                break
            case 5:
                scrollToRef(this.state.ref5)
                break
            case 6:
                scrollToRef(this.state.ref6)
                break
            case 7:
                scrollToRef(this.state.ref7)
                break
            case 8:
                scrollToRef(this.state.ref8)
                break
            case 9:
                scrollToRef(this.state.ref9)
                break
            case 10:
                scrollToRef(this.state.ref10)
                break
            case 11:
                scrollToRef(this.state.ref11)
                break
            case 12:
                scrollToRef(this.state.ref12)
                break
            case 13:
                scrollToRef(this.state.ref13)
                break
            case 14:
                scrollToRef(this.state.ref14)
                break
            case 15:
                scrollToRef(this.state.ref15)
                break
            case 16:
                scrollToRef(this.state.ref16)
                break
            case 17:
                scrollToRef(this.state.ref17)
                break
            case 18:
                scrollToRef(this.state.ref18)
                break
            case 19:
                scrollToRef(this.state.ref19)
                break
            case 20:
                scrollToRef(this.state.ref20)
                break
            default:
                scrollToRef(this.state.ref1)
                break
        }
    }

    renderStepsContent() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className='pageContents'>
                    <div className='stepsContainer'>
                        <span ref={this.state.ref1}></span>
                        <About3DS2 />
                        <span ref={this.state.ref2}></span>
                        <Building3DS2Integration />
                        <span ref={this.state.ref3}></span>
                        <ImplementingCardLookupRequest />
                        <span ref={this.state.ref4}></span>
                        <ImplementingAuthenticationRequest />
                        <span ref={this.state.ref5}></span>
                        <HandlingChallengeFlow />
                        <span ref={this.state.ref6}></span>
                        <HandlingDecoupledAuthFlow />
                        <span ref={this.state.ref7}></span>
                        <PerformingAuthorization />
                        <span ref={this.state.ref8}></span>
                        <Purchase3DS />
                        <span ref={this.state.ref9}></span>
                        <Preauth3DS />
                        <span ref={this.state.ref10}></span>
                        <Purchase3DSVault />
                        <span ref={this.state.ref11}></span>
                        <Preauth3DSVault />
                        <span ref={this.state.ref12}></span>
                        <Purchase3DSRec />
                        <span ref={this.state.ref16}></span>
                        <CavvPurchaseAppleGoogle />
                        <span ref={this.state.ref17}></span>
                        <CavvPreAuthAppleGoogle />
                        <span ref={this.state.ref18}></span>
                        <GooglePayTempToken />
                        <span ref={this.state.ref19}></span>
                        <GooglePayTokenPreauth />
                        <span ref={this.state.ref20}></span>
                        <GooglePayTokenPurchase />
                        <span ref={this.state.ref13}></span>
                        <Testing3DSIntegration />
                        <span ref={this.state.ref14}></span>
                        <MovingToProductionWith3DS />
                        <span ref={this.state.ref15}></span>
                        <References />
                    </div>
                    <Footer />
                </div>
            );
        }
        else {
            switch(this.props.selectedStep) {
                case 1:
                    return <About3DS2 />
                case 2:
                    return <Building3DS2Integration />
                case 3:
                    return <ImplementingCardLookupRequest />
                case 4:
                    return <ImplementingAuthenticationRequest />
                case 5:
                    return <HandlingChallengeFlow />
                case 6:
                    return <HandlingDecoupledAuthFlow />
                case 7:
                    return <PerformingAuthorization />
                case 8:
                    return <Purchase3DS />
                case 9:
                    return <Preauth3DS />
                case 10:
                    return <Purchase3DSVault />
                case 11:
                    return <Preauth3DSVault />
                case 12:
                    return <Purchase3DSRec />
                case 13:
                    return <Testing3DSIntegration />
                case 14:
                    return <MovingToProductionWith3DS />
                case 15:
                    return <References />
                default:
                    return null
            }
        }
    }

    renderResponseContent() {
        const { cardLookupResponse, authResponse, cavvLookupResponse, cavvPurchaseResponse, cavvPreAuthResponse, 
                resCavvPurchaseResponse,resCavvPreauthResponse,cavvPurchaseRecResponse,loading } = this.props

        switch(this.props.selectedResponse) {
            case 3:
                return <Response title="Actual Card Lookup Output" output={cardLookupResponse} loading={loading}/>
            case 4:
                return <Response title="Actual 3DS-Auth Output" output={authResponse} loading={loading}/>
            case 5:
                return <Response title="Actual Cavv Lookup Output" output={cavvLookupResponse} loading={loading}/>
            case 7:
                return <Response title="Actual Cavv Purchase Output" output={cavvPurchaseResponse} loading={loading}/>
            case 8:
                return <Response title="Actual Cavv Pre-Auth Output" output={cavvPreAuthResponse} loading={loading}/>
            case 9:
                return <Response title="Actual Res Cavv Purchase Output" output={resCavvPurchaseResponse} loading={loading}/>
            case 10:
                return <Response title="Actual Res Cavv Pre-Auth Output" output={resCavvPreauthResponse} loading={loading}/>
            case 11:
                return <Response title="Actual Cavv Purchase Recur Output" output={cavvPurchaseRecResponse} loading={loading}/>
            default:
                return null
        }
    }

    renderNextSteps() {
        const {selectedResponse, prevSuccStep, cardLookupSuccess, authSuccess, cavvLookupSuccess, eci, cavv} = this.props;

        if(prevSuccStep === selectedResponse && selectedResponse === 3 && cardLookupSuccess) {
            return (
                <div className='suggestedNextSteps'>
                    <span>Suggested Next Steps:</span>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '10px'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 4, featureId: _3DS2})}>3DS Authentication</span>
                    </div>
                </div>
            );
        }
        if(prevSuccStep === selectedResponse && selectedResponse === 4 && authSuccess) {
            if(eci === cavv) {
                return (
                    <div className='sugestedNextSteps'>
                        <h3 style={{marginTop: '0'}}>Suggested Next Steps:</h3>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                            <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 5, featureId: _3DS2})}>Make Challenge</span>
                        </div>
                    </div>
                );
            }
            else {
                return (
                    <div className='sugestedNextSteps'>
                        <h3 style={{marginTop: '0'}}>Suggested Next Steps:</h3>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                            <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 8, featureId: _3DS2})}>Cavv Purchase</span>
                            <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _3DS2})}>Cavv Pre-Auth</span> 
                            <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 10, featureId: _3DS2})}>Res Cavv Purchase</span>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                            <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 11, featureId: _3DS2})}>Res Cavv Pre-Auth</span>
                            <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 12, featureId: _3DS2})}>Cavv Purchase Recur</span> 
                        </div>
                    </div>
                );
            }
        }
        if(prevSuccStep === selectedResponse && selectedResponse === 5 && cavvLookupSuccess) {
            return (
                <div className='sugestedNextSteps'>
                    <h3 style={{marginTop: '0'}}>Suggested Next Steps:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 8, featureId: _3DS2})}>Cavv Purchase</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _3DS2})}>Cavv Pre-Auth</span> 
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 10, featureId: _3DS2})}>Res Cavv Purchase</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 11, featureId: _3DS2})}>Res Cavv Pre-Auth</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 12, featureId: _3DS2})}>Cavv Purchase Recur</span> 
                    </div>
                </div>
            );
        }
    }

    renderResponseList() {
        const { selectResponse, toggleResponsesList, isResponsesListOpen, selectedResponse, iframeOpen } = this.props;

        if(iframeOpen === false) {
            return (
                    <ResponseList
                        isOpen={isResponsesListOpen}
                        selection={selectedResponse}
                        responses={responses.filter((response) => (this.props.history.includes(response.id)))}
                        toggleResponseList={toggleResponsesList}
                        selectResponse={selectResponse}
                        featureId={_3DS2}
                    />
            );
        }
    }

    renderRightSide() {
        const { mode } = this.props;

        if(mode === 'interactive_tool') {
            return (
                <div className="rightContainer">
                    {this.renderResponseList()}

                    <div className="rightContents">
                        {this.renderResponseContent()}
                        {this.renderNextSteps()}
                    </div>
                </div>
            );
        }
        else {
            return null
        }
    }

    renderLeftSide() {
        const { selectedStep, selectStep, toggleStepsList, isStepsListOpen, mode } = this.props;
        const steps = FEATURES.threeDSTwo.steps;

        if(mode === 'interactive_tool') {
            return (
                <div className="leftContainer">
                   <StepsList 
                        isOpen={isStepsListOpen}
                        selection={selectedStep} 
                        toggleStepsList={toggleStepsList} 
                        steps={steps.filter((step) => [3, 4, 5, 8, 9, 10, 11, 12].includes(step.id))} //only interactive steps
                        selectStep={selectStep}
                        featureId={_3DS2}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
        else {
            return (
                <div className="documentContainer" onWheel={() => this.handleScrolling()}>
                    <StepsMenu 
                        selectStep={selectStep}
                        selection={selectedStep}
                        steps={steps}
                        featureId={_3DS2}
                        scrollIntoStep={(stepId) => this.scrollIntoStep(stepId)}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
    }

    renderUpArrow() {
        if(this.props.mode === 'integration_guide') {
            if(isIE) {
                return (
                    <div style={{ marginLeft: '42vw', marginTop: '55vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else if(isSafari) {
                return (
                    <div style={{ marginLeft: '45vw', marginTop: '30vh', paddingBottom: '1vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else {
                if(navigator.platform === "Win32") {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#129093;</span>
                        </div>
                    );
                }
                else {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#8679;</span>
                        </div>
                    );
                }
            }
        }
    }    

    render() {
        const { selectedStep, selectStep, history } = this.props;

        return (
            <div className="desktop">
                <Indicator 
                    title="3D Secure 2.2"
                    steps={FEATURES.threeDSTwo.steps}
                    renderConfig={() => <Configuration />}
                    selection={selectedStep}
                    selectStep={selectStep}
                    // isInteractive={() => [3, 4, 5, 8, 9, 10, 11, 12].includes(selectedStep)}
                    isInteractive={() => [].includes(selectedStep)}
                    history={history}
                />
                
                <div className="mainContainer">
                    {this.renderLeftSide()}
                    {this.renderRightSide()}
                    {this.renderUpArrow()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const selectedStep = state.threeDSTwo.stepsList.selection;
    const isStepsListOpen = state.threeDSTwo.stepsList.isOpen;
    const selectedResponse = state.threeDSTwo.responseList.selection;
    const isResponsesListOpen = state.threeDSTwo.responseList.isOpen;
    const { history, loading, prevSuccStep, iframeOpen } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { eci, cavv } = state.threeDSTwo.main.config;

    const { cardLookupResponse, authResponse, cavvLookupResponse, cavvPurchaseResponse, cavvPreAuthResponse,
            resCavvPurchaseResponse,resCavvPreauthResponse,cavvPurchaseRecResponse,
            cardLookupSuccess, authSuccess, cavvLookupSuccess, resCavvPurchaseSuccess, 
            resCavvPreauthSuccess, cavvPurchaseRecSuccess } = state.threeDSTwo.main;
    
    return {selectedStep, selectedResponse, isStepsListOpen, isResponsesListOpen, mode, history, loading, prevSuccStep,
            cardLookupResponse, authResponse, cavvLookupResponse, cavvPurchaseResponse, cavvPreAuthResponse,
            resCavvPurchaseResponse,resCavvPreauthResponse,cavvPurchaseRecResponse,
            resCavvPurchaseSuccess, resCavvPreauthSuccess, cavvPurchaseRecSuccess,
            cardLookupSuccess, authSuccess, cavvLookupSuccess, eci, cavv, iframeOpen};
}

export default connect(mapStateToProps, {toggleStepsList, toggleResponsesList, selectResponse, selectStep, selectMode, selectFeature})(ThreeDSTwo);
